/**
 * Throttle a function to limit its execution rate.
 *
 * @param {Function} callback - The function to throttle.
 * @param {number} limit - The time limit in milliseconds.
 */
export function throttle(callback, limit) {
  let lastCallback;
  let lastRan;

  return (...args) => {
    if (!lastRan) {
      callback(args);
      lastRan = Date.now();
    } else {
      clearTimeout(lastCallback);
      const elapsed = Date.now() - lastRan;

      lastCallback = setTimeout(() => {
        if (elapsed >= limit) {
          callback(args);
          lastRan = Date.now();
        }
      }, limit - elapsed);
    }
  };
}
